import api from '../../service/modules/investment'
import index_api from '../../service/modules/index'

export default {
    namespaced: true,
    state: {
        investorAreaCode: '',
        investmentTitle: '招商引资', // 头部标题
        advisoryObjectList: [], // ##### 留言管理 咨询对象 下拉框
        investmentMessageList: [], // ##### #留言版列表
        userType: 0, // 用户类型 0 ：啥也不是，1:超管，2:省文旅厅
        rejectReasonL: '', // 驳回原因
        messageOption: {
            statue: '',
            advisoryObjectCode: '0'
        },
        investorOption: {
            areaCode: '',
            rankingCode: ''
        },
        activityOption: {
            orgId: '',
            busiManageTypeCode: ''
        },
        informationOption: {
            location: '',
            category: 1,
            statue: ''
        },
        pendingOption: {
            location: '',
            type: '',
            status: '',
            progress: ''
        },
        allLocation: {},
        isGovernmentStacff: false
    },
    getters: {
        getInvestmentTitle (state) {
            return state.investmentTitle
        },
        getAdvisoryObjectList (state) {
            return state.advisoryObjectList
        },
        getInvestmentMessageList (state) {
            return state.investmentMessageList
        },
        getUserType (state) {
            return state.userType
        },
        getRejectReasonL (state) {
            return state.rejectReasonL
        },
        getMessageOption (state) {
            return state.messageOption
        },
        getInvestorOption (state) {
            return state.investorOption
        },
        getActivityOption (state) {
            return state.activityOption
        },
        getInformationOption (state) {
            return state.informationOption
        },
        getPendingOption (state) {
            return state.pendingOption
        },
        getAllLocation (state) {
            return state.allLocation
        }

    },
    mutations: {
        setGovernmentStacff: (state, val) => {
            state.isGovernmentStacff = val
        },
        inInvestmentTitle: (state, data) => {
            state.investmentTitle = data;
        },
        inIdvisoryObjectList: (state, data) => {
            state.advisoryObjectList = data;
        },
        inInvestmentMessageList: (state, data) => {
            state.investmentMessageList = data;
        },
        inUserType: (state, data) => {
            state.userType = data;
        },
        inRejectReasonL: (state, data) => {
            state.rejectReasonL = data;
        },

        inMessageOption: (state, data) => {
            state.messageOption = data;
        },
        inInvestorOption: (state, data) => {
            state.investorOption = data;
        },
        inActivityOption: (state, data) => {
            state.activityOption = data;
        },
        inInformationOption: (state, data) => {
            state.informationOption = data;
        },
        inPendingOption: (state, data) => {
            state.pendingOption = data;
        },
        inAllLocation: (state, data) => {
            state.allLocation = data;
        }

    },
    actions: {
        setInvestmentTitle: (context, data) => {
            context.commit('inInvestmentTitle', data)
        },
        setRejectReasonL: (context, data) => {
            context.commit('inRejectReasonL', data)
        },

        setMessageOption: (context, data) => {
            context.commit('inMessageOption', data)
        },
        setInvestorOption: (context, data) => {
            context.commit('inInvestorOption', data)
        },
        setActivityOption: (context, data) => {
            context.commit('inActivityOption', data)
        },
        setInformationOption: (context, data) => {
            context.commit('inInformationOption', data)
        },
        setPendingOption: (context, data) => {
            context.commit('inPendingOption', data)
        },
        delInvestor (context, data) {
            return new Promise((resolve, reject) => {
                api.delInvestor(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                })
            })
        },
        setAdvisoryObjectList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAdvisoryObjectList(data).then(res => {
                    let arr = []
                    res.data.forEach(element => {
                        arr.push({
                            'text': element.advisoryObjectValue,
                            'value': element.advisoryObjectCode
                        })
                    });
                    context.commit('inIdvisoryObjectList', arr)
                    resolve(arr)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },
        setInvestmentMessageList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestmentMessageList(data).then(res => {
                    context.commit('inInvestmentMessageList', res.data)
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },
        setInvestmentMessageDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestmentMessageDetails(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },
        getInvestorInfo: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestorInfo(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },
        getInvestList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestList(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                });
            })
        },

        getInvestLoadBy: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestLoadBy(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        removeInvest: (context, data) => {
            return new Promise((resolve, reject) => {
                api.removeInvest(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getAttractList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAttractList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getAllProjectType: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAllProjectType(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getBusinessList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getBusinessList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getContactUsList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getContactUsList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getCompanyPartnerList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getCompanyPartnerList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getFindOperatingConfigList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getFindOperatingConfigList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getAttractDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAttractDetails(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getBusinessDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getBusinessDetails(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getContactUsDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getContactUsDetails(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getCompanyPartnerDetails: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getCompanyPartnerDetails(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getOperatingDetail: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getOperatingDetail(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        deleteAttract: (context, data) => {
            return new Promise((resolve, reject) => {
                api.deleteAttract(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        deleteContactUs: (context, data) => {
            return new Promise((resolve, reject) => {
                api.deleteContactUs(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        deleteCompanyPartner: (context, data) => {
            return new Promise((resolve, reject) => {
                api.deleteCompanyPartner(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        updateAttract: (context, data) => {
            return new Promise((resolve, reject) => {
                api.updateAttract(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                });
            })
        },

        updateEnable: (context, data) => {
            return new Promise((resolve, reject) => {
                api.updateEnable(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                });
            })
        },

        updateDisable: (context, data) => {
            return new Promise((resolve, reject) => {
                api.updateDisable(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                });
            })
        },

        verifyAttract: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyAttract(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        verifyContact: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyContact(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        verifyCompanyPartner: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyCompanyPartner(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        verifyAgree: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyAgree(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        verifyDisagree: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyDisagree(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        verifyBusiness: (context, data) => {
            return new Promise((resolve, reject) => {
                api.verifyBusiness(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        addPrMessageFealRecord: (context, data) => {
            return new Promise((resolve, reject) => {
                api.addPrMessageFealRecord(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getInvestmentMessageDealList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestmentMessageDealList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getProgressAll: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getProgressAll(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getProjectList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getProjectList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getProjectDetail: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getProjectDetail(data).then(res => {
                    if (res.data.status == 1) {
                        // api.getProjectDetailAttract({ attract_id: data.id }).then(thing => {
                        //     if (thing.code !== 500) {
                        //         let arr = ['projectName', 'location', 'locationName', 'projectType', 'projectTypeName', 'projectName', 'projectEntity', 'investorRequirement', 'projectLaunchYear',
                        //             'investmentMoney', 'financingMode', 'projectOverview', 'projectContent', 'supportingCondition', 'preferentialPolicy',
                        //             'cooperationMode', 'marketPrediction', 'benefitAnalysis', 'riskAnalysis', 'contractOrg', 'contractPerson', 'contractPhone',
                        //             'fax', 'email', 'photoPath', 'filePath'
                        //         ]
                        //         arr.forEach(element => {

                        //             if (typeof(thing.data[element]) != "undefined") {

                        //                 res.data[element] = thing.data[element]
                        //             }
                        //         });
                        //     }
                        //     // resolve(res.data)

                        // }).catch(err => {
                        //     // reject(err.data)
                        // });
                    } else {
                    }
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getProjectInvestorTracking: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getProjectInvestorTracking(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getAttractInvestmentId: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAttractInvestmentId(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getTotalUndone: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getTotalUndone(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getPublicUnDone: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getPublicUnDone(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getVerifying: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getVerifying(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getTotalMessage: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getTotalMessage(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getPublicTotal: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getPublicTotal(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getProgressNum: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getProgressNum(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getInvestorNum: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestorNum(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getPrInvestmentManage: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getPrInvestmentManage(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        deleteAttractById: (context, data) => {
            return new Promise((resolve, reject) => {
                api.deleteAttractById(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        postAttractVerify: (context, data) => {
            return new Promise((resolve, reject) => {
                api.postAttractVerify(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getInvestorList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestorList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getDockingNegotiateList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getDockingNegotiateList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getDockingNegotiate: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getDockingNegotiate(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getInvestorProjectList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getInvestorProjectList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        orgUnitList: (context, data) => {
            return new Promise((resolve, reject) => {
                api.orgUnitList(data).then(res => {
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getAllLocation: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getAllLocation(data).then(res => {
                    context.commit('inAllLocation', res.data)
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        getUnionAuth: (context, data) => {
            return new Promise((resolve, reject) => {
                index_api.getUnionAuth(data).then(res => {
                    // context.commit('inUserType', data)
                    if (res.data.ATTRACT_INVESTMENT[0].areaCode && res.data.ATTRACT_INVESTMENT[0].areaCode == '530000') {
                        context.commit('inUserType', 2)
                    }
                    if (res.data.ATTRACT_INVESTMENT[0].roleCodes && res.data.ATTRACT_INVESTMENT[0].roleCodes.includes('superUser')) {
                        context.commit('inUserType', 1)
                    }
                    resolve(res.data)
                }).catch(res => {
                    reject(res.data)
                });
            })
        },

        updateBusinessUsing: (context, data) => {
            return new Promise((resolve, reject) => {
                api.updateBusinessUsing(data).then(res => {
                    resolve(res)
                }).catch(res => {
                    reject(res)
                });
            })
        }

    }

}
